import PinVerificationStep from './PinVerificationStep';

export default PinVerificationStep;
